export const module13InitialState = {
  module13: {
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    coins: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      CactusBarell: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CactusPrickly: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StegoBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StegoGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Tent: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      TentOld: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      LongNeckRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      LongNeckGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Canteen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Backpack: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Plant1: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Plant2: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Bandanna: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Hat: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      RaptorDark: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      RaptorLight: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Volcano: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      TRex: {
        unlocked: false,
        x: 0,
        y: 0,
      },
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
    },
  },
};

export const Module13Reducer = (state = module13InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE13_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        CactusBarell: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CactusPrickly: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StegoBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StegoGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Tent: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        TentOld: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        LongNeckRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        LongNeckGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Canteen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Backpack: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Plant1: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Plant2: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Bandanna: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Hat: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        RaptorDark: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        RaptorLight: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Volcano: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        TRex: {
          unlocked: false,
          x: 0,
          y: 0,
        },
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]].unlocked = true;
              tempRewards[Object.keys(tempRewards)[j]].x = obj[i]?.x_multiplier;
              tempRewards[Object.keys(tempRewards)[j]].y = obj[i]?.y_multiplier;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[], "tokens_earned":0}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"CactusBarell\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"Tent\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"LongNeckRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"RaptorLight\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module13: {
          ...state.module13,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
          coins: JSON.parse(tempObj)?.tokens_earned,
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module13InitialState,
      };
    }
    case 'MODULE13_SET_DAY': {
      return {
        ...state,
        module13: {
          ...state.module13,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE13_SET_GameDetials': {
      return {
        ...state,
        module13: {
          ...state.module13,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE13_SET_stepCompleted': {
      return {
        ...state,
        module13: {
          ...state.module13,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE13_SET_dayCompleted': {
      return {
        ...state,
        module13: {
          ...state.module13,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE13_SET_CAMERAOPEN': {
      return {
        ...state,
        module13: {
          ...state.module13,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE13_SET_KEY': {
      return {
        ...state,
        module13: {
          ...state.module13,
          keys: action.payload,
        },
      };
    }
    case 'MODULE13_SET_COIN': {
      return {
        ...state,
        module13: {
          ...state.module13,
          coins: action.payload,
        },
      };
    }
    case 'MODULE13_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module13: {
          ...state.module13,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE13_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module13: {
          ...state.module13,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE13_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module13: {
          ...state.module13,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE13_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module13: {
          ...state.module13,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE13_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module13: {
          ...state.module13,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE13_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module13: {
          ...state.module13,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE13_SET_REWARD11': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            CactusBarell: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD11_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            CactusBarell: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD12': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            CactusPrickly: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD12_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            CactusPrickly: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD21': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            StegoBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD21_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            StegoBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD22': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            StegoGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD22_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            StegoGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD31': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Tent: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD31_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Tent: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD32': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            TentOld: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD32_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            TentOld: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD41': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            LongNeckRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD41_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            LongNeckRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD42': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            LongNeckGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD42_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            LongNeckGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD51': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Canteen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD51_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Canteen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD52': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Backpack: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD52_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Backpack: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD61': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Plant1: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD61_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Plant1: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD62': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Plant2: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD62_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Plant2: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD71': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Bandanna: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD71_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Bandanna: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD72': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Hat: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD72_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Hat: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD81': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            RaptorDark: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD81_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            RaptorDark: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD82': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            RaptorLight: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_REWARD82_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            RaptorLight: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_PRIZE1': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Volcano: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_PRIZE1_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            Volcano: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_PRIZE2': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            TRex: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_PRIZE2_POSITION': {
      return {
        ...state,
        module13: {
          ...state.module13,
          rewards: {
            ...state.module13.rewards,
            TRex: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE13_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module13: {
          ...state.module13,
          unlockedDays: {
            ...state.module13.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE13_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module13: {
          ...state.module13,
          unlockedDays: {
            ...state.module13.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE13_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module13: {
          ...state.module13,
          unlockedDays: {
            ...state.module13.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE13_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module13: {
          ...state.module13,
          unlockedDays: {
            ...state.module13.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE13_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module13: {
          ...state.module13,
          unlockedDays: {
            ...state.module13.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE13_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module13: {
          ...state.module13,
          unlockedDays: {
            ...state.module13.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE13_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module13: {
          ...state.module13,
          unlockedDays: {
            ...state.module13.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE13_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module13: {
          ...state.module13,
          unlockedDays: {
            ...state.module13.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
export default Module13Reducer;
